import { Checkbox, Radio } from 'react-icheck';
import { InputHidden } from '../Core';
import IonRangeSlider from 'react-ion-slider';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

export default class FiltersForm extends Component
{
    constructor(props) {
        super(props);

        this.state = {
            form_id: "filtersForm_" + uniqid(),
            tour_categories: this.props.tours.meta.tour_categories,
        };
        
        this.submitForm = this.submitForm.bind(this);
    }
    
    submitForm(event)
    {
        // console.log("submit", event.target);
        if(this.props.stopReloadOnSubmit)
            event.preventDefault();
        
        this.props.submitFiltersForm(this.state.form_id);
    }
    
    render()
    {
        const { max_duration, min_duration, max_price, min_price, tourRating, request, sort_by, tours } = this.props;
        // console.log("request", request);
        return (
            <div>
                <form id={this.state.form_id} onSubmit={this.submitForm}>
                    <InputHidden name="sort_by" value={sort_by.slug} readOnly={true} />

                    <div className="py-4 border-bottom">
                        <h5 className="font-weight-bold body-font mb-3">Price</h5>

                        <IonRangeSlider 
                            type={"double"} 
                            min={tours.meta.min_price || 0} 
                            max={tours.meta.max_price || 0}
                            prefix={"$"}
                            skin="round"
                            from={min_price || 0}
                            to={max_price || 0}
                            onFinish={(event) => {this.props.changePriceRange(this.state.form_id, event)}}
                        />

                        <input
                            type="hidden"
                            name="min_price"
                            value={min_price || 0}
                            readOnly={true}
                        />

                        <input
                            type="hidden"
                            name="max_price"
                            value={max_price || 0}
                            readOnly={true}
                        />
                    </div>

                    {!this.props.noRating &&
                        <div className="py-4 border-bottom">
                            <h5 className="font-weight-bold body-font mb-3">Ratings</h5>

                            <ul className="list-group m-0 z-depth-0">
                                {
                                    _.times(5, (parent_key) => {
                                        let rating = 5 - parent_key;

                                        return (
                                            <li key={parent_key} className="list-group-item px-0 py-1 border-0">
                                                <div className="media">
                                                    <div className="mr-2 align-self-center">
                                                        <Radio
                                                            name="rating"
                                                            value={rating}
                                                            radioClass="iradio_minimal"
                                                            onChange={(event) => { this.props.changeRating(event)}}
                                                            checked={tourRating == rating}
                                                        />
                                                    </div>
                                                    <div className="media-body align-self-center">
                                                        {
                                                            _.times(rating, (child_key) => {

                                                                return(
                                                                    <span key={child_key} className={"primary-text fa" + '' + " fa-lg fa-star mr-1"}></span>
                                                                )
                                                            })
                                                        }
                                                    </div>
                                                </div>
                                            </li>
                                        )
                                    })
                                }
                            </ul>
                        </div>
                    }

                    <div className="py-4 border-bottom">
                        <h5 className="font-weight-bold body-font mb-3">Categories</h5>

                        <ul className="list-group m-0 z-depth-0">
                            {
                                this.state.tour_categories.map((tour_category, key) => {

                                    return (
                                        <li key={key} className="list-group-item px-0 py-2 border-0">
                                            <div className="media">
                                                <div className="mr-2 align-self-center">
                                                    <Checkbox
                                                        name="tour_category[]"
                                                        value={tour_category.slug}
                                                        checkboxClass="icheckbox_minimal"
                                                        onChange={(event) => {this.props.changeTourCategories(event)}}
                                                        defaultChecked={(
                                                            _.findIndex(request.tour_category, (_tour_category) => _tour_category == tour_category.slug) > -1 ? true : false
                                                        )}
                                                    />
                                                </div>
                                                <div className="media-body align-self-center position-relative" style={{ top: '1px' }}>
                                                    {
                                                        !_.isEmpty(tour_category.icon) &&
                                                        <i className={"fa fa-fw fa-lg mr-2 " + tour_category.icon}></i>
                                                    }

                                                    <span className="grey-text">{tour_category.name}</span>
                                                </div>
                                            </div>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>

                    {!this.props.noDuration &&
                        <div className="pt-4">
                            <h5 className="font-weight-bold body-font mb-3">Duration</h5>

                            <IonRangeSlider 
                                type={"double"} 
                                min={tours.meta.min_duration || 0} 
                                max={tours.meta.max_duration || 0}
                                postfix={" hrs"}
                                skin="round"
                                from={min_duration || 0}
                                to={max_duration || 0}
                                onFinish={(event) => {this.props.changeDurationRange(this.state.form_id, event)}}
                            />

                            <input
                                type="hidden"
                                name="min_duration"
                                value={min_duration || 0}
                                readOnly={true}
                            />

                            <input
                                type="hidden"
                                name="max_duration"
                                value={max_duration || 0}
                                readOnly={true}
                            />
                        </div>
                    }

                    <div className="pt-4">
                        <button className="btn btn-block btn-primary border-0 rounded-0 font-weight-bold px-3 px-lg-5" type="submit">
                            <span className="d-none d-lg-inline">Filter</span><i className="fa fa-fw fa-filter ml-lg-3"></i>
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/ToursIndex/FiltersForm.js